// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container Shell Layer */
.edit-server-container {
  padding: 24px;
  max-width: 650px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  background-color: #f8fafc;
  min-height: 100vh;
}

/* Header Integration Area */
.edit-server-header {
  margin-bottom: 28px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 16px;
}

.edit-server-header h2 {
  margin: 0;
  font-size: 22px;
  color: #1e293b;
  font-weight: 800;
  letter-spacing: -0.5px;
}

.edit-server-header p {
  margin: 6px 0 0 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.5;
}

/* Alert Notification Boxes */
.edit-server-alert-error {
  background-color: #fee2e2;
  color: #991b1b;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #fca5a5;
}

.edit-server-alert-success {
  background-color: #dcfce7;
  color: #166534;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #86efac;
}

/* Core Form Configuration Grid */
.edit-server-form {
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Read-Only Hardware Metrics Grid Box */
.edit-server-metrics-box {
  background-color: #f1f5f9;
  padding: 14px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  font-size: 13px;
}

.edit-server-metrics-box span {
  color: #64748b;
}

.edit-server-uuid-text {
  font-family: monospace;
  color: #2563eb;
  font-weight: 600;
  margin-top: 2px;
  word-break: break-all;
}

.edit-server-load-text, .edit-server-uptime-text {
  font-family: monospace;
  font-weight: 600;
  color: #334155;
  margin-top: 2px;
}

/* Form Input Groups */
.edit-server-form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.edit-server-form-group label {
  font-size: 14px;
  fontWeight: 700;
  color: #334155;
}

.edit-server-input {
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  color: #0f172a;
}

.edit-server-input:focus {
  border-color: #0f172a;
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.05);
}

.edit-server-input-ip {
  font-family: monospace;
}

/* Bottom Action Buttons Bar Layout */
.edit-server-actions-bar {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
  border-top: 1px solid #f1f5f9;
  padding-top: 16px;
}

/* Cancel / Back Button Style */
.edit-server-btn-back {
  padding: 10px 20px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  cursor: pointer;
  font-weight: bold;
  color: #475569;
  font-size: 14px;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.edit-server-btn-back:hover {
  background-color: #f8fafc;
  border-color: #94a3b8;
}

/* Submit & Sync Button Style */
.edit-server-btn-submit {
  padding: 10px 24px;
  border-radius: 6px;
  border: none;
  background-color: #0f172a;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.15s ease;
}

.edit-server-btn-submit:hover {
  background-color: #1e293b;
}

.edit-server-btn-submit:disabled {
  background-color: #94a3b8;
  cursor: not-allowed;
}

/* ==========================================================================
   📱 Mobile View Responsive Tweaks
   ========================================================================== */
@media (max-width: 500px) {
  .edit-server-container {
    padding: 16px;
  }
  
  .edit-server-metrics-box {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .edit-server-actions-bar {
    flex-direction: column-reverse;
  }
  
  .edit-server-btn-back, .edit-server-btn-submit {
    width: 100%;
    text-align: center;
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Server/EditServer.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gGAAgG;EAChG,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;+EAE+E;AAC/E;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;AACF","sourcesContent":["/* Container Shell Layer */\n.edit-server-container {\n  padding: 24px;\n  max-width: 650px;\n  margin: 0 auto;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  background-color: #f8fafc;\n  min-height: 100vh;\n}\n\n/* Header Integration Area */\n.edit-server-header {\n  margin-bottom: 28px;\n  border-bottom: 1px solid #e2e8f0;\n  padding-bottom: 16px;\n}\n\n.edit-server-header h2 {\n  margin: 0;\n  font-size: 22px;\n  color: #1e293b;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n}\n\n.edit-server-header p {\n  margin: 6px 0 0 0;\n  color: #64748b;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* Alert Notification Boxes */\n.edit-server-alert-error {\n  background-color: #fee2e2;\n  color: #991b1b;\n  padding: 12px 16px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid #fca5a5;\n}\n\n.edit-server-alert-success {\n  background-color: #dcfce7;\n  color: #166534;\n  padding: 12px 16px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid #86efac;\n}\n\n/* Core Form Configuration Grid */\n.edit-server-form {\n  background: #ffffff;\n  padding: 24px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Read-Only Hardware Metrics Grid Box */\n.edit-server-metrics-box {\n  background-color: #f1f5f9;\n  padding: 14px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  font-size: 13px;\n}\n\n.edit-server-metrics-box span {\n  color: #64748b;\n}\n\n.edit-server-uuid-text {\n  font-family: monospace;\n  color: #2563eb;\n  font-weight: 600;\n  margin-top: 2px;\n  word-break: break-all;\n}\n\n.edit-server-load-text, .edit-server-uptime-text {\n  font-family: monospace;\n  font-weight: 600;\n  color: #334155;\n  margin-top: 2px;\n}\n\n/* Form Input Groups */\n.edit-server-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.edit-server-form-group label {\n  font-size: 14px;\n  fontWeight: 700;\n  color: #334155;\n}\n\n.edit-server-input {\n  padding: 10px 12px;\n  border-radius: 6px;\n  border: 1px solid #cbd5e1;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  color: #0f172a;\n}\n\n.edit-server-input:focus {\n  border-color: #0f172a;\n  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.05);\n}\n\n.edit-server-input-ip {\n  font-family: monospace;\n}\n\n/* Bottom Action Buttons Bar Layout */\n.edit-server-actions-bar {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 16px;\n  border-top: 1px solid #f1f5f9;\n  padding-top: 16px;\n}\n\n/* Cancel / Back Button Style */\n.edit-server-btn-back {\n  padding: 10px 20px;\n  border-radius: 6px;\n  border: 1px solid #cbd5e1;\n  background-color: #ffffff;\n  cursor: pointer;\n  font-weight: bold;\n  color: #475569;\n  font-size: 14px;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.edit-server-btn-back:hover {\n  background-color: #f8fafc;\n  border-color: #94a3b8;\n}\n\n/* Submit & Sync Button Style */\n.edit-server-btn-submit {\n  padding: 10px 24px;\n  border-radius: 6px;\n  border: none;\n  background-color: #0f172a;\n  color: #ffffff;\n  font-weight: bold;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.15s ease;\n}\n\n.edit-server-btn-submit:hover {\n  background-color: #1e293b;\n}\n\n.edit-server-btn-submit:disabled {\n  background-color: #94a3b8;\n  cursor: not-allowed;\n}\n\n/* ==========================================================================\n   📱 Mobile View Responsive Tweaks\n   ========================================================================== */\n@media (max-width: 500px) {\n  .edit-server-container {\n    padding: 16px;\n  }\n  \n  .edit-server-metrics-box {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  \n  .edit-server-actions-bar {\n    flex-direction: column-reverse;\n  }\n  \n  .edit-server-btn-back, .edit-server-btn-submit {\n    width: 100%;\n    text-align: center;\n    padding: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
